import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import firebase from "firebase";
import FieldValue = firebase.firestore.FieldValue;
import { TalesArea } from "../../../utils/types/TalesArea";

export const addArea = createAsyncThunk("aree/add", async (area: TalesArea) => {
  try {
    return await db.collection("aree").add({
      ...area,
      show: `${area.show}` === "true",
      creationDate: FieldValue.serverTimestamp(),
    });
  } catch (e: any) {
    console.log(e);

    return Promise.reject(`Area non aggiunta, ${e.message}`);
  }
});
